import { AppRouteProps } from "@bsm/component";
import { AuthRoutes, LogoutRoutes } from "@bsm/login";
import { UserDetailsRoutes, UserManagementRoutes } from "@bsm/user-management";
import { StudentsRoutes } from "@bsm/students";
import { InvoiceRoutes } from "@bsm/invoice";
import AdminLayout from "components/layout/AdminLayout";
import AuthLayout from "components/layout/AuthLayout";
import ClientLayout from "components/layout/ClientLayout";
import OrganisationAccessLayer from "container/OrganisationAccessLayer";
import HareaContainer from "container/HareaContainer";
import { UserAuthRoutes } from "./auth/AuthRoutes";
import { HomeRoutes } from "./home/HomeRoutes";
import { NotificationRoutes } from "@bsm/notification";
import { TranslationRoutes } from '@bsm/translation'
import NotFound from "../components/NotFound";
import { DataExports } from "./data/DataRoutes";

export const Routes: Array<AppRouteProps> = [
    {
        path: ":lang",
        element: <HareaContainer />,
        children: [
            {
                path: "",
                element: <OrganisationAccessLayer />,
                children: [
                    {
                        path: "admin",
                        title: `std_home`,
                        element: <AdminLayout />,
                        children: [
                            ...HomeRoutes,
                            ...NotificationRoutes,
                            ...UserManagementRoutes,
                            ...TranslationRoutes,
                            ...DataExports,
                            ...StudentsRoutes,
                            ...InvoiceRoutes
                        ],
                    }
                ],
            },
            ...LogoutRoutes,
            ...UserAuthRoutes,
        ],
    },
    {
        path: '*',
        element: <NotFound />
    }
];
